module.exports = __webpack_public_path__ + "static/media/dante.906b0448.webp";